// src/components/ui/SoundToggle.jsx
import React, { useEffect } from "react";
import { useFeedback } from "../../contexts/FeedbackContext";
import { Volume2, VolumeX } from "lucide-react";

export default function SoundToggle({ className = "" }) {
  const { prefs, setSoundEnabled, play, buzz } = useFeedback();
  const muted = !prefs.soundEnabled;

  function toggle() {
    setSoundEnabled(muted);
    if (muted) {
      play("tap");
      buzz("light");
    }
  }

  useEffect(() => {
    const onKey = (e) => {
      // Guard against undefined keys and modifier combos
      const key = e && typeof e.key === "string" ? e.key.toLowerCase() : "";
      if (key === "m" && !e.metaKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault?.();
        toggle();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [muted]); // eslint-disable-line

  const outer =
    "relative inline-flex items-center rounded-full h-7 w-12 border border-[var(--mudo-border)]/80 " +
    "bg-[var(--mudo-bg-soft)]/80 cursor-pointer focus:outline-none focus:ring-2 " +
    "focus:ring-[var(--mudo-primary)]/75 transition";

  const thumbBase =
    "absolute left-1 h-5 w-5 rounded-full bg-[var(--mudo-bg)]/95 flex items-center justify-center " +
    "text-[var(--mudo-text-muted)] text-[11px] transition-transform";

  const thumbClass = `${thumbBase} ${muted ? "" : "translate-x-5"}`;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={!muted}
      aria-label={muted ? "Unmute sounds (M)" : "Mute sounds (M)"}
      title={muted ? "Sound off" : "Sound on"}
      className={`${outer} ${className}`}
    >
      <span className={thumbClass}>
        {muted ? (
          <VolumeX className="h-3.5 w-3.5" />
        ) : (
          <Volume2 className="h-3.5 w-3.5" />
        )}
      </span>
    </button>
  );
}
